import React, { useContext, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { LicenseManager } from 'ag-grid-enterprise';
import {
  Watermark,
  WidgetHeader,
  FrequencyAgGridWidgetWrapper,
  AgGridTableWrapper,
  Container,
  APIAlert,
} from '@mummssoftware/common-ui';
import {
  VFGlobalContext,
  SET_ORDERS_MODE,
} from '@mummssoftware/global-context/VFGlobalContext';
import {
  OrdersGlobalContext,
  SET_DISPLAY_CONFIRMATION,
} from '@mummssoftware/global-context/OrdersGlobalContext';
import { verifyFreqEditingData } from '@mummssoftware/utils/orders/orders-utils';
import { FlexRowDiv } from '@mummssoftware/common-ui/style';
import { RoleGroupSelector } from '../../components/sections/RoleGroupSelector';
import { ComplianceViewButton } from '../ComplianceView';
import { EditRowDialog } from '../EditFrequency';
import { CarePlanFrequencyContext } from '../../context';
import { CPFContext } from '../Context/CPFContext';
import { CarePlanFrequencyTable } from '../../components/sections/CarePlanFrequencyTable';
import defaults from '../../translations/en.json';
import { canShowAddRole } from '../../editPolicy';

import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';
import 'ag-grid-community/dist/styles/ag-grid.css';

LicenseManager &&
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY as string);

type CarePlanFrequencyComponentProps = {
  rgHash: mumms.HashedRoleGroup;
  viewModePrint: boolean;
};

export const CarePlanFrequencyComponent = (
  props: CarePlanFrequencyComponentProps,
) => {
  const { rgHash, viewModePrint } = props;
  const {
    appTitle,
    smallWidget,
    watermark,
    startLoadingTime,
    onWidgetReady,
    onClick,
    onRemove,
    doNotShow,
    readOnly,
  } = useContext(CarePlanFrequencyContext);
  const { isCPFAgency, errorAPIInfo, clearAPIerror, tableRgHash } = useContext(
    CPFContext,
  );
  const { VFordersMode, VForderData, dispatchVF } = useContext(VFGlobalContext);
  const { dispatchOrders } = useContext(OrdersGlobalContext);

  const {
    props: {
      grid: gridTheme = {
        className: '',
        headerHeight: 25,
      },
    },
  } = useTheme() as any;

  useEffect(() => {
    const loadingDuration = (Date.now() - startLoadingTime) / 1000;
    onWidgetReady && onWidgetReady('CarePlanFrequency' as mumms.ComponentName);
    console.log('## CARE PLAN FREQUENCY WIDGET END ##', loadingDuration, 's');
  }, []);

  const hashForTable = tableRgHash || rgHash;

  const resetEditingStatus = () => {
    const roleGroups = Object.values(hashForTable);
    roleGroups.forEach((roleGroup) => {
      const carePlans = Object.values(roleGroup.frequencies);
      carePlans.forEach((carePlan) => {
        carePlan.editing = false;
      });
    });
    if (VFordersMode) {
      dispatchOrders({ type: SET_DISPLAY_CONFIRMATION, payload: true });
      dispatchVF({ type: SET_ORDERS_MODE, payload: false });
    }
    if (onClick) {
      onClick();
    }
  };

  const showAddRole = canShowAddRole({
    isCPFAgency: !!isCPFAgency,
    VFordersMode,
    smallWidget,
    readOnly,
  });

  return (
    <Container>
      <WidgetHeader
        appTitle={appTitle || defaults.carePlanFrequency}
        versionInfo={`CP - Visit Frequency v${process.env.REACT_APP_CARE_PLAN_FREQUENCY_VERSION}, SmartChart v${process.env.REACT_APP_VERSION}`}
        smallWidget={smallWidget}
        onClick={resetEditingStatus}
        onRemove={onRemove}
        doNotShow={doNotShow}
        // disabled={VFordersMode && !isFreqDataVerified}
      >
        <FlexRowDiv id="role-group-selector-comp">
          {showAddRole && (
            <RoleGroupSelector rgHash={rgHash} smallWidget={smallWidget} />
          )}
          <ComplianceViewButton />
        </FlexRowDiv>
        {/* {VFordersMode && (
          <div style={{ color: 'red', paddingLeft: '5px' }}>
            {verifyEditingData() && defaults.missingData}
          </div>
        )} */}
      </WidgetHeader>
      <FrequencyAgGridWidgetWrapper
        id="care-plan-freq-body"
        smallWidget={smallWidget}
      >
        {watermark && watermark.show ? (
          <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
        ) : null}
        <APIAlert
          errorInfo={errorAPIInfo}
          handleClose={() => clearAPIerror()}
        />
        <AgGridTableWrapper className={`${gridTheme.className} light`}>
          <div style={{ height: '99%' }}>
            <CarePlanFrequencyTable
              rgHash={hashForTable}
              smallWidget={smallWidget}
              viewModePrint={viewModePrint}
              readOnly={readOnly}
            />
          </div>
        </AgGridTableWrapper>
      </FrequencyAgGridWidgetWrapper>
      <EditRowDialog />
    </Container>
  );
};

export default CarePlanFrequencyComponent;
